import { Screen } from "../components/Screen";
import { Footer } from "../components/Footer";
import { CSSProperties, useEffect, useState } from "react";
import { Font } from "../constants/fonts";
import { Colors } from "../constants/colors";
import { Icons } from "../constants/icons";

export default function Sobre() {
    const [isMobile, setIsMobile] = useState(false);
    
    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth <= 768);
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    if (isMobile) {
        return (
            <Screen>
                <div style={mobileStyles.containerTop}>
                    <div style={mobileStyles.card}>
                        <div style={mobileStyles.title}>
                            A mobilidade que nasceu da empatia.
                        </div>
                    </div>
                    
                    <img src="/Rectangle%2055.svg" alt="ClickMob sobre" style={mobileStyles.logo}/>
                    
                    <div style={mobileStyles.card}>
                        <div style={mobileStyles.text}>
                            O ClikMob surgiu do desejo de transformar a relação entre motoristas e passageiros, tornando o transporte urbano mais humano, seguro e equilibrado. Criamos um aplicativo que valoriza quem presta o serviço e oferece a quem usa um atendimento de qualidade, com atenção e respeito.
                        </div>
                        <br/>
                        <div style={mobileStyles.text}>
                            Com foco em tecnologia, empatia e segurança, o ClikMob quer inspirar uma nova forma de se mover pela cidade — conectando pessoas, histórias e destinos.
                        </div>
                    </div>
                </div>
                
                <div style={mobileStyles.containerBottom}>
                    <img src="/undraw_destination_fkst 1.svg" alt="ClickMob destinos" style={mobileStyles.logo2}/>
                    
                    <div style={mobileStyles.featuresContainer}>
                        <div style={mobileStyles.featureItem}>
                            <Icons
                                color={Colors.white}
                                name="car"
                                size={28}
                            />
                            <div style={mobileStyles.featureText}>
                                <b>Valorização do motorista:</b> mais ganhos, respeito e suporte.
                            </div>
                        </div>
                        
                        <div style={mobileStyles.featureItem}>
                            <Icons
                                color={Colors.white}
                                name="message"
                                size={28}
                            />
                            <div style={mobileStyles.featureText}>
                                <b>Atendimento humanizado:</b> cada corrida é uma experiência de confiança.
                            </div>
                        </div>
                        
                        <div style={mobileStyles.featureItem}>
                            <Icons
                                color={Colors.white}
                                name="shield"
                                size={28}
                            />
                            <div style={mobileStyles.featureText}>
                                <b>Segurança real:</b> botão SOS integrado a órgãos públicos.
                            </div>
                        </div>
                        
                        <div style={mobileStyles.featureItem}>
                            <Icons
                                color={Colors.white}
                                name="gift"
                                size={28}
                            />
                            <div style={mobileStyles.featureText}>
                                <b>Pontos ClikMob:</b> passageiros e motoristas com descontos em estabelecimentos parceiros.
                            </div>
                        </div>
                    </div>
                </div>
                <Footer/>
            </Screen>
        );
    }

    // Return original (desktop) intacto
    return (
        <Screen>
            <div style={styles.conteinerTop}>
                <div>
                    <div style={styles.card}>
                        <div style={styles.title}>
                            A mobilidade que nasceu da empatia.
                        </div>
                    </div>
                    <br></br>
                    <div style={styles.card}>
                        <div style={styles.text}>
                            O ClikMob surgiu do desejo de transformar a relação entre motoristas e passageiros, tornando  o transporte urbano mais humano, seguro e equilibrado.  Criamos um aplicativo que valoriza quem presta o serviço e oferece a quem usa um  atendimento de qualidade, com atenção e respeito.
                        </div>
                        <br></br>
                        <div style={styles.text}>
                            Com foco em tecnologia, empatia e segurança, o ClikMob quer inspirar uma nova forma de se  mover pela cidade — conectando pessoas, histórias e destinos.
                        </div>
                    </div>
                </div>
                <div>
                     <img src="/Rectangle%2055.svg" alt="ClickMob logo" style={styles.logo}/>
                </div>
            </div>
            <div style={styles.conteinerBottom}>
                <div>
                    <div style={styles.line}>
                        <Icons
                            color={Colors.white}
                            name="car"
                            size={35}
                        />
                        <div style={styles.text}>
                            <b>Valorização do motorista:</b> mais ganhos, respeito e suporte.
                        </div>
                    </div>
                    <div style={styles.line}>
                         <Icons
                            color={Colors.white}
                            name="message"
                            size={35}
                        />
                        <div style={styles.text}>
                            <b>Atendimento humanizado:</b> cada corrida é uma experiência de confiança.
                        </div>
                    </div>
                    <div style={styles.line}>
                         <Icons
                            color={Colors.white}
                            name="shield"
                            size={35}
                        />
                        <div style={styles.text}>
                            <b>Segurança real:</b> botão SOS integrado a órgãos públicos.
                        </div>
                    </div>
                    <div style={styles.line}>
                         <Icons
                            color={Colors.white}
                            name="gift"
                            size={35}
                        />
                        <div style={styles.text}>
                            <b>Pontos ClikMob:</b> passageiros e motoristas com descontos em estabelecimentos parceiros.
                        </div>
                    </div>
                </div>
                <div>
                    <img src="/undraw_destination_fkst 1.svg" alt="ClickMob logo" style={styles.logo2}/>
                </div>
            </div>
            <Footer/>
        </Screen>
    );
}

// Estilos desktop originais (mantidos intactos)
const styles:  { [key: string]: CSSProperties } = {
    conteinerTop: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        gap: 30,
        padding: 55
    },
    title: {
        fontSize: Font.title2.fontSize,
        color: Colors.white,
        textAlign: 'justify',
        fontWeight: Font.title2.fontWeight
    },
    text: {
        fontSize: Font.menu.fontSize,
        textAlign: 'justify',
        color: Colors.white
    },
    card: {
        padding: '25px',
        borderRadius: '20px',
        backgroundColor: Colors.primary
    },
    logo: {
        width: 565
    },
    conteinerBottom: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        padding: 60,
        backgroundColor: Colors.primary
    },
    text2: {
        fontSize: Font.text.fontSize,
        textAlign: 'justify',
        color: Colors.white
    },
    line: {
        width: '90%',
        display: 'flex',
        alignItems: 'center',
        gap: 15,
        margin: '60px 0'
    },
    logo2: {
        height: 455,
        borderRadius: 20
    }
}

// Estilos mobile otimizados
const mobileStyles: { [key: string]: CSSProperties } = {
    containerTop: {
        display: 'flex',
        flexDirection: 'column',
        gap: 25,
        padding: '25px 20px',
        backgroundColor: Colors.gray,
    },
    title: {
        fontSize: Font.title2.fontSize * 0.85,
        color: Colors.white,
        textAlign: 'center',
        fontWeight: Font.title2.fontWeight,
        lineHeight: 1.3,
    },
    text: {
        fontSize: Font.menu.fontSize * 0.95,
        textAlign: 'center',
        color: Colors.white,
        lineHeight: 1.5,
    },
    card: {
        padding: '20px',
        borderRadius: '15px',
        backgroundColor: Colors.primary,
        width: '100%',
    },
    logo: {
        width: '100%',
        maxWidth: 350,
        height: 'auto',
        borderRadius: '15px',
        margin: '0 auto',
        display: 'block',
    },
    containerBottom: {
        display: 'flex',
        flexDirection: 'column',
        padding: '40px 20px',
        backgroundColor: Colors.primary,
        gap: 40,
    },
    logo2: {
        width: '100%',
        maxWidth: 280,
        height: 'auto',
        borderRadius: 15,
        margin: '0 auto',
        display: 'block',
    },
    featuresContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: 30,
    },
    featureItem: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 15,
        textAlign: 'center',
    },
    featureText: {
        fontSize: Font.menu.fontSize * 0.9,
        color: Colors.white,
        lineHeight: 1.4,
    },
};